import { DynamicsSettings } from 'app/model/dataflow/dataset-settings/dynamics-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { Metamodel } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.commonDataService.dataflowSettings
})
export class DataverseSettings extends DynamicsSettings {
    public getDatasetType(): string {
        return adfModelTypeMap.commonDataService.datasetType;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Dataverse;
    }

    public getIconClass(): string {
        return 'i-100x100-Dataverse';
    }
}
